// 루트 - Home
export const ROUTE_ROOT = '/';

// 로그인 - Sign In
export const ROUTE_SIGN_IN = '/sign-in';

// 3D 뷰어 - 3D Viewer
export const ROUTE_3D_VIEWER = '/3d-viewer';

// 사용자 목록
export const ROUTE_USER_MANAGEMENT = '/user-management';
export const ROUTE_USER_MANAGEMENT_LIST = `${ROUTE_USER_MANAGEMENT}/list`;
